/**
 * Created by ori on 29/07/16.
 */
'use strict';
import {observable} from 'mobx';

import Login from './Login';
import Signup from './Signup';
import Verify from './Verify';
// import BuildStore from './BuildStore';

// export default (initialState) => new Main(initialState);
export default initialState => {
    var state = Object.assign({
        userData:{},
        ui: {
            login: Login(),
            signup: Signup(),
            verify: Verify(),

        },
        // buildStore: BuildStore(),
    }, initialState);
    return observable(state);
};


// WEBPACK FOOTER //
// ./src/js/store/index.js